import { render, staticRenderFns } from "./SelectStaff.vue?vue&type=template&id=5f8c861a&scoped=true"
import script from "./SelectStaff.vue?vue&type=script&lang=js"
export * from "./SelectStaff.vue?vue&type=script&lang=js"
import style0 from "./SelectStaff.vue?vue&type=style&index=0&id=5f8c861a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8c861a",
  null
  
)

export default component.exports